
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Customer } from '../models/customer.model';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class CustomersMappingService {
    private _authService: AuthService;
    private basePath = "api/Customer";

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }
    getAllUsers() {
        return this.http.get(`${this.basePath}/GetAllUsers/`, this.getAuthHeader(true));
    }

    getLinkedCustomerMappingGroup(UserId: string) {
        return this.http.get(`${this.basePath}/GetLinkedCustomerMappingGroup/` + UserId, this.getAuthHeader(true));
    }

    getSourceCustomersForMapping(UserId: string) {
        return this.http.get(`${this.basePath}/GetSourceCustomersForMapping/` + UserId, this.getAuthHeader(true));
    }

    getTargetCustomersForMapping(UserId: string) {
        return this.http.get(`${this.basePath}/GetTargetCustomersForMapping/` + UserId, this.getAuthHeader(true));
    }

    updateCustomerMappingGroup(UserId: string, targetCustomers: Customer[]) {
        const data = {
            UserId: UserId,
            targetCustomers: targetCustomers,
        };
        return this.http.post(`${this.basePath}/UpdateCustomerMappingGroup`, data, this.getAuthHeader(true));
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        const options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/customers-mapping.service.ts